import React from "react";

import { ROUTES, TABLE_NAMES } from "@/shared";

import LayoutNoDetails from "./LayoutNoDetails";
import LayoutWithDetails from "./LayoutWithDetails";

interface ILayoutWrapperProps {
  route: ROUTES;
  tableName: TABLE_NAMES;
  showDetailsSection: boolean;
  children: React.ReactNode;
  infoIconTooltip?: string;
}

const LayoutWrapper = ({
  route,
  tableName,
  showDetailsSection,
  children,
  infoIconTooltip,
}: ILayoutWrapperProps) => {
  const renderLayout = () => {
    if (!showDetailsSection) {
      return (
        <LayoutNoDetails
          route={route}
          tableName={tableName}
          infoIconTooltip={infoIconTooltip}
        >
          {children}
        </LayoutNoDetails>
      );
    }

    return (
      <LayoutWithDetails
        route={route}
        tableName={tableName}
        infoIconTooltip={infoIconTooltip}
      >
        {children}
      </LayoutWithDetails>
    );
  };

  return renderLayout();
};

export default LayoutWrapper;
